import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import { authenticatedRoute } from '../../../pages/AuthenticatedView.route';

export const startReviewRoute = createRoute({
    getParentRoute: () => authenticatedRoute,
    path: "/reviews/start",
    component: lazyRouteComponent(() => import('./StartReview.page'))
});
